const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches;

const titleCache = {};

async function fetchTitle(videoId) {
  if (titleCache[videoId]) return titleCache[videoId];

  try {
    const res = await fetch(
      `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`
    );

    if (!res.ok) throw new Error("oEmbed failed");

    const data = await res.json();
    titleCache[videoId] = data.title;
    return data.title;
  } catch {
    return "Video";
  }
}

export default function initVideoPlayer(root = document) {
  const videos = root.querySelectorAll(".video");

  videos.forEach((el) => {
    if (el.dataset.initialised === "true") return;
    el.dataset.initialised = "true";

    const videoId = el.dataset.videoId;
    const noCookie = el.dataset.noCookie === "true";

    const iframe = el.querySelector("iframe");
    const button = el.querySelector(".video__cover");
    const label = el.querySelector(".visually-hidden");

    if (!iframe || !button) return;

    // Accessibility baseline
    iframe.setAttribute("aria-hidden", "true");
    iframe.setAttribute("tabindex", "-1");

    // Async title enhancement
    fetchTitle(videoId).then((title) => {
      const safeTitle = title || "Video";

      if (label) {
        label.textContent = `Play video: ${safeTitle}`;
      }

      button.setAttribute("aria-label", `Play video: ${safeTitle}`);
      iframe.setAttribute("title", `Video: ${safeTitle}`);
    });

    function activateVideo() {
      const base = noCookie
        ? "https://www.youtube-nocookie.com/embed/"
        : "https://www.youtube.com/embed/";

      const autoplay = prefersReducedMotion ? "" : "?autoplay=1";

      iframe.src = `${base}${videoId}${autoplay}`;

      iframe.removeAttribute("aria-hidden");
      iframe.removeAttribute("tabindex");

      el.classList.add("is-playing");

      // safer focus
      setTimeout(() => {
        iframe.focus();
      }, 0);
    }

    // Click
    button.addEventListener("click", activateVideo);

    // Keyboard
    button.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        activateVideo();
      }
    });
  });
}